export default IconCampfire => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-campfire" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 21l16 -4" />
  <path d="M20 21l-16 -4" />
  <path d="M12 15a4 4 0 0 0 4 -4c0 -3 -2 -3 -2 -8c-4 2 -6 5 -6 8a4 4 0 0 0 4 4z" />
</svg>`;